require('./polyfill.js');
require('whatwg-fetch');



//////////////////
// WEBPACK FOOTER
// ./packages/z-shop-js-env/index.js
// module id = 378
// module chunks = 0